import { useEffect, useState } from "react";
import axiosWithAuth from "../utils/axiosWithAuth";
import { getOrderTaxSummary } from "../utils/orderTaxes";

import useOrderTaxSummary from "../hooks/useOrderTaxSummary";

import OrderTaxRows from "./OrderTaxRows";

export default function OrderTaxesValue({ order }) {
  const summary = getOrderTaxSummary(order);
  const [details, setDetails] = useState(null);
  const [failed, setFailed] = useState(false);
  const resolvedSummary = useOrderTaxSummary(details || order);
  useEffect(() => {
    let cancelled = false;
    setDetails(null);
    setFailed(false);
    if (summary.amount === null || (summary.rate === null && !order.businesses_id && !order.business_id && !order.restaurant_id)) {
      axiosWithAuth().get(`/api/restaurant/order/getOrdersDetails/${order.id}`)
        .then(({ data }) => {
          if (!cancelled) setDetails(data.data.order);
        })
        .catch(() => { if (!cancelled) setFailed(true); });
    }
    return () => { cancelled = true; };
  }, [order.id, order.businesses_id, order.business_id, order.restaurant_id, summary.amount, summary.rate]);
  if (resolvedSummary.amount !== null) return <OrderTaxRows summary={resolvedSummary} />;
  return failed ? "Unavailable" : "Loading...";
}
